import React, { FC } from 'react';
import { NavHashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';

import { useMediaSwitch, Stack, Typography, useMobile, useDesktop } from 'Modules/ui3';
import { TFunction, useTranslation } from 'Modules/core/i18n';

import { CollapsedContainer } from '../../components/CollapsedContainer';


const PARAGRAPH_COUNT = 16;

const useFaq = (t: TFunction) => {
    const items = [];
    for (let i = 1; i <= PARAGRAPH_COUNT; i++) {
        items.push(
            <CollapsedContainer
                key={i}
                title={t(`paragraph${i}.title`)}
                text={(
                    <Trans
                        i18nKey={`faq:paragraph${i}.text`}
                        components={{
                            br: <br />,
                            newsLink: <NavHashLink to='#news' smooth exact />,
                            issueLink: <Link to='/information' />,
                            telegramLink: <a href='https://t.me/cfa_hub' target='_blank' rel='noopener noreferrer'>Telegram-канал</a>,
                            operatorMail: <a href='mailto:operator@cfahub.ru'>operator@cfahub.ru</a>,
                            dfaNews: <a href='https://cfahub.ru/news/00118' target='_blank' rel='noopener noreferrer'>крупнейшая</a>,
                            mainLink: <a href='https://cfahub.ru/' target='_blank' rel='noopener noreferrer'>сайта</a>,
                        }}
                    />
                )}
            />,
        );
    }
    return items;
};

export const FAQ: FC = () => {
    const { t } = useTranslation('faq');
    const isMobile = useMobile();
    const isDesktop = useDesktop();
    const faqItems = useFaq(t);
    return (
        <Stack
            px={useMediaSwitch(12, 6, 5)}
            pt={useMediaSwitch(22, 16, 8)}
            pb={useMediaSwitch(22, 6, 20)}
            alignItems='center'
            bgcolor='#fff'
            zIndex={1}
            {...!isDesktop && {
                sx: ({ spacing }) => ({
                    borderBottomLeftRadius: spacing(isMobile ? 8 : 10),
                    borderBottomRightRadius: spacing(isMobile ? 8 : 10),
                }),
            }}
        >
            <Stack
                spacing={useMediaSwitch(22, 12, 6)}
                width='100%'
                maxWidth='1200px'
            >
                <Typography
                    fontFamily='Hauora'
                    fontSize={useMediaSwitch('72px', '56px', '32px')}
                    fontWeight={700}
                    lineHeight={isMobile ? '1.25' : '1.3'}
                    color='#242424'
                >
                    {t('title')}
                </Typography>
                <Stack spacing={2}>
                    {faqItems}
                </Stack>
            </Stack>
        </Stack>
    );
};
